import { defineStore } from 'pinia'


/***
 * import { loadingStore } from '@/store/loading.js';
 * let loading =loadingStore()
 * loading.showLoading()
 * that.loading.showLoading()
 * that.loading.hideLoading()
 * 
 * * */
export const loadingStore = defineStore('loading',{
  state: () => ({
    isShow:false,
    text:'加载中...'
  }),
  getters: {
    isshow:false
  },
  actions: {
    showLoading(text='加载中...',time=5000){
        this.text=text;
        if(!this.isShow){
          this.isShow=true;
          setTimeout(() => {
              //最长5秒会自动消失
              this.isShow=false;
          }, time);
        }
    },
    hideLoading(){
        this.isShow=false;
    }
  },
})